module.exports = __webpack_public_path__ + "img/fj.74e854d9.svg";